import { defineStore } from "pinia";
import { ref } from "vue";
import { logger } from "@/infrastructure/services/LoggerService";
import { fetchValueLists } from "../infrastructure/api/valueListApi";
export const useValueListStore = defineStore("valueLists", () => {
    const lists = ref([]);
    const isLoading = ref(false);
    const loadError = ref(false);
    let latestLoad = 0;
    /** Only the latest call writes the state: a late answer to an older call is discarded. */
    async function load() {
        const thisLoad = ++latestLoad;
        isLoading.value = true;
        loadError.value = false;
        try {
            const next = await fetchValueLists();
            if (thisLoad === latestLoad)
                lists.value = next;
        }
        catch (error) {
            if (thisLoad !== latestLoad)
                return;
            logger.error("Failed to load the value lists", error);
            lists.value = [];
            loadError.value = true;
        }
        finally {
            if (thisLoad === latestLoad)
                isLoading.value = false;
        }
    }
    /** A failed load leaves `lists` empty, so the next screen to ask loads again. */
    async function ensureLoaded() {
        if (lists.value.length === 0 && !isLoading.value)
            await load();
    }
    return { lists, isLoading, loadError, load, ensureLoaded };
});
